import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/img/gfx-services.jpg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  width: "970",
  height: "252"
}, null, -1)
const _hoisted_2 = { id: "main-content" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<h1>Our Services</h1><h2><strong>Temporary Executives</strong></h2><p>Moksha can provide a resource that is adaptable, an excellent communicator, integrates well with teams and is a “fixer”. The more dire the straits the organisation may find itself in, the better. Moksha&#39;s consultants are accomplished in a variety of industries and across disciplines, and able to make and implement strategic decisions. Implementation is the focus; whether re-organising, down-sizing, starting anew, or revitalising, we have a solution.</p><h2><strong>Business Plans</strong></h2><p>Moksha provides research, development and/or execution of detailed business plans.</p><h2><strong>Strategic Workshops</strong></h2><p>We are available to present or facilitate workshops and/or give presentations based on sector analysis and research, or actual customer experience. </p><h2><strong>Research</strong></h2><p>We offer desk and face-to-face consultations with key stakeholders.</p><h2><strong>Corporate Stress Management</strong></h2>", 10)
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Moksha has developed and offers a specialised programme centred on self-management and aimed at unleashing potential. (Please see our ")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Stress Management")
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" page for more details). ")
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", null, "The typical engagement is over a period of time and focuses on measurable implementation, which allows a risk/performance based element.", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Moksha Enterprises is run by founder "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "http://www.chrisloker.com/",
    target: "_blank"
  }, "Chris Loker"),
  /*#__PURE__*/_createTextVNode(", with additional talent brought in as and when required. Chris has a Bachelor of Business Science from UCT, is a (Fellow of the Institute of Life and Pension Advisors), and has a Diploma in Financial Markets & Instruments. He has experience in Internet banking, retail treasury, cards, online broking, call centres and investment products, as well as in other entrepreneurial ventures, such as a partnership in "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "http://www.polari-tea.co.za/",
    target: "_blank"
  }, "Polari-Tea"),
  /*#__PURE__*/_createTextVNode(", a herbal tea business. He practises yoga regularly, as well as road-running and open water swimming. In 1990 he led a South African delegation to an international student conference in Japan on sustainable development and has come full circle since then to active involvement in sustainability solutions. ")
], -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("h2", null, "Strategy is... ", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("table", {
  width: "100%",
  border: "0",
  cellspacing: "0",
  cellpadding: "11"
}, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("td", { bgcolor: "#069" }, [
      /*#__PURE__*/_createElementVNode("h2", { style: {"color":"#FFF"} }, [
        /*#__PURE__*/_createTextVNode(" \"Making trade-offs in competing and choosing what not to do! The greatest barriers to strategy are often internal.\" ― "),
        /*#__PURE__*/_createElementVNode("em", null, "Michael Porter, Harvard Business School")
      ])
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("p", null, [
        _hoisted_13,
        _createVNode(_component_router_link, {
          to: "/stress-management",
          target: "_blank"
        }, {
          default: _withCtx(() => [
            _hoisted_14
          ]),
          _: 1
        }),
        _hoisted_15
      ]),
      _hoisted_16,
      _hoisted_17,
      _hoisted_18,
      _hoisted_19
    ])
  ], 64))
}